module.exports = __webpack_public_path__ + "7afa369f57863dc018709b38aee59c82.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/winter-chalet-empty.png
// module id = 347
// module chunks = 0